module.exports = __webpack_public_path__ + "static/media/arrow_right_blue.ae9a86a8.svg";